
















































































































































































































































































import { Component, Provide, Mixins, Vue } from 'vue-property-decorator';
import MixinChartRaw from '@/plugins/podolib/services/helper/mixins/chart/raw';

export enum ESide {
  Left = 'left',
  Right = 'right',
}

@Component
export default class ChartRawRatioPropulsion extends Mixins(MixinChartRaw) {
  @Provide() valuePosition: any = {
    high: 79.46,
    normal: 125.63,
    low: 171.8,
  };
  @Provide() hipClass: any = {
    low: 'cl-neutral',
    high: 'cl-warning',
    normal: 'cl-success',
  };
  @Provide() ankleClass: any = {
    low: 'cl-warning',
    high: 'cl-neutral',
    normal: 'cl-success',
  };

  get propulsionSpeed(): any {
    const left = this.values.computed_data.left.aggregates.propulsion_speed.avg.toFixed(2);
    const right = this.values.computed_data.right.aggregates.propulsion_speed.avg.toFixed(2);
    return { left, right };
  }
  get oscillationSpeed(): any {
    const left = this.values.computed_data.left.aggregates.swing_speed.avg.toFixed(2);
    const right = this.values.computed_data.right.aggregates.swing_speed.avg.toFixed(2);
    return { left, right };
  }
  get propulsionRatio(): any {
    const left = Math.round((this.propulsionSpeed.left / this.oscillationSpeed.left) * 100);
    const right = Math.round((this.propulsionSpeed.right / this.oscillationSpeed.right) * 100);
    return { left, right };
  }
  get musclesClass() {
    let musclesClass: any = {
      left: {
        hip: null,
        ankle: null,
      },
      right: {
        hip: null,
        ankle: null,
      },
    };
    for (const side of ['left', 'right']) {
      musclesClass[side].hip = this.hipClass[this.getRatioRange(this.propulsionRatio[side]).type];
      musclesClass[side].ankle = this.ankleClass[this.getRatioRange(this.propulsionRatio[side]).type];
    }
    return musclesClass;
  }

  getFormatValue(value: number) {
    const operator = value > 100 ? '-' : '+';
    return `${operator}${Math.abs(value - 100)}%`;
  }
  getRatioRange(value: number) {
    switch (true) {
      case value < 95:
        return {
          type: 'high',
          class: 'cl-warning',
          pos: this.valuePosition.high,
        };
      case value > 105:
        return {
          type: 'low',
          class: 'cl-warning',
          pos: this.valuePosition.low,
        };
      default:
        return {
          type: 'normal',
          class: 'cl-success',
          pos: this.valuePosition.normal,
        };
    }
  }
  getCheckIndicatortranslate(side: string, checkIndicator: boolean) {
    const leftSide = side === 'left';
    if (checkIndicator) {
      return leftSide ? 'translate(28 0)' : 'translate(193 0)';
    } else {
      return `translate(${leftSide ? 15 : 180} -1)`;
    }
  }
  getArrowIndicatortranslate(side: string, checkIndicator: boolean) {
    const leftSide = side === 'left';
    if (checkIndicator) {
      return leftSide ? 'translate(-2 0)' : 'translate(220 0)';
    } else {
      return `translate(${leftSide ? -15 : 207} -1)`;
    }
  }
}
